import { useState } from 'react';

import { observer } from 'mobx-react';

import { useStores } from '../../../stores/useStores';
import { Loader } from '../../Loader/Loader';

import { CasinoHeader } from './CasinoHeader';
import styles from './GenericHeader.module.scss';
import RiveHeader from './rive/RiveHeader';

export const GenericHeader = observer(() => {
  const { uiStore, coinTypeStore } = useStores();
  const [riveLoadingError, setRiveLoadingError] = useState(false);

  if (uiStore.bannersLoading) {
    return (
      <div className={styles.loaderWrapper}>
        <Loader />
      </div>
    );
  }

  const handleRiveLoadError = () => {
    setRiveLoadingError(true);
  };

  const { lobby_cc, lobby_sc, lobby_animation_only } = uiStore.bannerByPage;

  if (!lobby_cc || !lobby_sc) {
    return <CasinoHeader />;
  }

  const bgImage = coinTypeStore.coinType === 'GC' ? lobby_cc : lobby_sc;
  const hasAnimation =
    (bgImage?.desktopBanner?.animationUrl && bgImage?.desktopBanner?.animationBackgroundUrl) ||
    lobby_animation_only?.desktopBanner?.animationUrl;

  return (
    <>
      {uiStore.bannerAnimationFlag && hasAnimation && !riveLoadingError ? (
        <RiveHeader
          animationOnly={lobby_animation_only}
          bannerCC={lobby_cc}
          bannerSC={lobby_sc}
          currentCoinType={coinTypeStore.coinType}
          setRiveLoadingError={handleRiveLoadError}
        />
      ) : (
        <picture>
          {bgImage.mobile && <source media="(max-width: 768px)" srcSet={bgImage.mobile} />}
          <img alt="CrownCoinsCasino header" className={styles.banner} src={bgImage.desktop} />
        </picture>
      )}
    </>
  );
});
